export const SITE = {
  name: "London Empire Institution",
  address: "Engineers Way, Wembley Park HA9 0FJ",
  addressFull: "Engineers Way, Wembley Park, London HA9 0FJ",
  phoneDisplay: "07850006144",
  phoneTel: "+447850006144",
  whatsapp: "https://wa.me/447850006144",
  email: "arabiclanguageempire1@gmail.com",
};

export const NAV_LINKS = [
  { id: "dialects", label: "Dialects" },
  { id: "levels", label: "Levels" },
  { id: "pricing", label: "Pricing" },
  { id: "tutors", label: "Tutors" },
  { id: "how-it-works", label: "How it works" },
  { id: "contact", label: "Contact" },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1646229227468-ba6eb534d368?crop=entropy&cs=srgb&fm=jpg&q=85",
  calligraphy:
    "https://images.unsplash.com/photo-1601480905449-90fca867ad37?crop=entropy&cs=srgb&fm=jpg&q=85",
  classroom:
    "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?crop=entropy&cs=srgb&fm=jpg&q=85",
  chalkboard:
    "https://images.unsplash.com/photo-1561089489-f13d5e730d72?crop=entropy&cs=srgb&fm=jpg&q=85",
  wembley:
    "https://images.unsplash.com/photo-1779449607162-3365eb42df7f?crop=entropy&cs=srgb&fm=jpg&q=85",
};

export const DIALECTS = {
  flagship: {
    id: "levantine",
    name: "Levantine Arabic",
    arabic: "الشامية",
    tag: "Main preferred dialect",
    region: "Lebanon · Syria · Jordan · Palestine",
    description:
      "Our flagship programme. The spoken Arabic of the Levant — instantly usable in conversation and widely understood across Arab media, music and cinema.",
  },
  others: [
    {
      id: "msa",
      name: "Modern Standard Arabic",
      arabic: "الفصحى",
      tag: "Formal & literary",
      region: "Official Arab League & literature",
      description:
        "The written and formal language — for news, journalism, official documents and classical literature.",
    },
    {
      id: "gulf",
      name: "Gulf Arabic",
      arabic: "الخليجية",
      tag: "Khaleeji",
      region: "UAE · Qatar · Saudi Arabia · Kuwait",
      description:
        "The spoken Arabic of the Arabian Gulf — for business, travel and cultural connection in the region.",
    },
    {
      id: "egyptian",
      name: "Egyptian Dialect",
      arabic: "المصرية",
      tag: "Culture & media",
      region: "Egypt & pan-Arab entertainment",
      description:
        "The dialect of cinema, music and comedy — understood wherever Arabic is spoken.",
    },
  ],
};

export const LEVELS = [
  {
    num: "01",
    name: "Beginner",
    description:
      "From your very first word — the alphabet, sounds and the confidence to hold simple everyday conversations.",
  },
  {
    num: "02",
    name: "Intermediate",
    description:
      "Build real fluency — longer conversations, reading, and handling daily life and work situations in Arabic.",
  },
  {
    num: "03",
    name: "Advanced",
    description:
      "Refine and polish — debate, nuance, media and literature, until Arabic works for you at full speed.",
  },
];

export const PRICING = {
  individual: [
    {
      id: "6hrs",
      hours: "6",
      rate: "£30",
      total: "£180",
      badge: "Popular starter",
      features: [
        "1-to-1 private lessons",
        "90–120 minute sessions",
        "Flexible schedule — any time",
        "Your dialect, your pace",
      ],
    },
    {
      id: "12hrs",
      hours: "12",
      rate: null,
      total: "£300",
      badge: "2 hours free",
      sub: "Pay for 10 hours at £30/hr, learn 12",
      features: [
        "1-to-1 private lessons",
        "2 hours completely free",
        "Flexible schedule — any time",
        "Dedicated tutor throughout",
      ],
    },
    {
      id: "30hrs",
      hours: "30",
      rate: "£27",
      total: "£810",
      badge: "Maximum savings",
      features: [
        "1-to-1 private lessons",
        "Reduced rate of £27 per hour",
        "Flexible schedule — any time",
        "Complete journey to fluency",
      ],
    },
  ],
  group: [
    {
      id: "group-12hrs",
      hours: "12",
      rate: "£45",
      total: "£540",
      badge: null,
      features: [
        "Group lessons",
        "90–120 minute sessions",
        "Learn together, speak together",
        "Flexible scheduling",
      ],
    },
    {
      id: "group-30hrs",
      hours: "30",
      rate: "£45",
      total: "£1,260",
      badge: "2 hours free",
      sub: "Pay for 28 hours at £45/hr, learn 30",
      features: [
        "Group lessons",
        "2 hours completely free",
        "Full level progression",
        "Flexible scheduling",
      ],
    },
  ],
};

export const buildEnquiryMailto = (opts = {}) => {
  const subject = "Lesson enquiry — London Empire Institution";
  const lines = [
    "Hello,",
    "",
    "I would like to arrange Arabic lessons.",
    ...(opts.hours ? [`Package: ${opts.hours} hours`] : []),
    ...(opts.type
      ? [`Lesson type: ${opts.type === "individual" ? "1-to-1 individual" : "Group"}`]
      : []),
    ...(opts.dialect ? [`Dialect: ${opts.dialect}`] : []),
    "",
    "Name:",
    "Availability:",
    "",
  ];
  return `mailto:${SITE.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(
    lines.join("\n")
  )}`;
};
